type DirectPurchaseOnlyVariantArgs = {
  faxPricingDirectPurchaseOnly?: boolean;
  canDirectPurchase?: boolean;
  isHelloSign: boolean;
  isFreeTier: boolean;
};

export function isExperimentCouponApplied(
  experimentCouponCode?: string | null,
  couponPrice?: string | null,
) {
  return Boolean(
    experimentCouponCode &&
      experimentCouponCode.trim() !== '' &&
      couponPrice != null &&
      couponPrice !== '',
  );
}

export function buildDirectPurchaseUrl(
  baseUrl: string,
  couponCode?: string | null,
) {
  let url = baseUrl;

  if (!url.includes('direct_purchase=')) {
    url += `${url.includes('?') ? '&' : '?'}direct_purchase=1`;
  }

  if (couponCode && couponCode.trim() !== '' && !url.includes('coupon_code=')) {
    url += `&coupon_code=${encodeURIComponent(couponCode.trim())}`;
  }

  return url;
}

export function shouldShowDirectPurchaseOnlyVariant({
  faxPricingDirectPurchaseOnly,
  canDirectPurchase,
  isHelloSign,
  isFreeTier,
}: DirectPurchaseOnlyVariantArgs) {
  if (faxPricingDirectPurchaseOnly && !canDirectPurchase) {
    return false;
  }

  return Boolean(faxPricingDirectPurchaseOnly && !isHelloSign && !isFreeTier);
}
